var _g, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgButtonDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_267:1787)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 42,
    r: 42,
    fill: "#187330"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.1154 27.1347H51.7692V26.101C51.7692 24.3883 50.2195 23 48.3077 23H43.6923C41.7805 23 40.2308 24.3883 40.2308 26.101V27.1347H33.8846C32.2915 27.1347 31 28.2917 31 29.7188V31.7862C31 32.3571 31.5166 32.8198 32.1538 32.8198H59.8462C60.4834 32.8198 61 32.3571 61 31.7862V29.7188C61 28.2917 59.7085 27.1347 58.1154 27.1347ZM42.5385 26.101C42.5385 25.5312 43.0563 25.0673 43.6923 25.0673H48.3077C48.9438 25.0673 49.4615 25.5312 49.4615 26.101V27.1347H42.5385V26.101Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.076 34.4574C32.8641 34.457 32.6951 34.6204 32.7048 34.8161L33.6516 53.8209C33.7391 55.5798 35.2992 56.9598 37.2029 56.9629L55.2296 56.9926C57.1333 56.9957 58.6981 55.621 58.7916 53.8624L59.8034 34.8607C59.8139 34.6651 59.6454 34.5012 59.4335 34.5008L33.076 34.4574ZM50.9982 37.2307C50.9992 36.6243 51.5313 36.1341 52.1871 36.1351C52.843 36.1362 53.3733 36.6282 53.3723 37.2346L53.3478 51.502C53.3468 52.1084 52.8148 52.5986 52.1589 52.5976C51.5031 52.5965 50.9727 52.1045 50.9738 51.4981L50.9982 37.2307ZM45.063 37.2209C45.064 36.6145 45.5961 36.1243 46.2519 36.1254C46.9078 36.1264 47.4381 36.6184 47.4371 37.2248L47.4127 51.4922C47.4116 52.0986 46.8796 52.5889 46.2237 52.5878C45.5679 52.5867 45.0375 52.0947 45.0386 51.4883L45.063 37.2209ZM39.1278 37.2111C39.1289 36.6048 39.6609 36.1145 40.3167 36.1156C40.9726 36.1167 41.5029 36.6087 41.5019 37.215L41.4775 51.4825C41.4764 52.0888 40.9444 52.5791 40.2885 52.578C39.6327 52.5769 39.1024 52.0849 39.1034 51.4785L39.1278 37.2111Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_267:1787",
    x: 0,
    y: 0,
    width: 92,
    height: 92,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_267:1787"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_267:1787",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonDelete);
export default __webpack_public_path__ + "static/media/button_delete.489ca364.svg";
export { ForwardRef as ReactComponent };